import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed, getCurrentInstance, ref} from 'vue';
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import ChatForm from "~/chat/vue/widget/form/ChatForm.vue";
import Dictionary from "~/ts/library/Dictionary";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import {CLIENT_CAPTCHA_FIELD_NAME, CLIENT_DATA_TYPE_EMAIL} from "~/chat/ts/data/IClient";
import {COLLECT_CONTACT_FIELD_REQUIRED, CollectContactFields} from "~/chat/ts/data/ISiteParams";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {IField, ITextField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {ConfigStore} from "~/chat/ts/store/Config";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ExportChatForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const KEY_EMAIL = "email";
const KEY_CAPTCHA = CLIENT_CAPTCHA_FIELD_NAME;


let model = ref<{ [KEY_EMAIL]?: string }>();
let isLoading = ref(false);

let visible = ChatTabStore.isExportChatDisplayed;

function onVisibleUpdate(value: boolean) {
    ChatTabStore.SET_EXPORT_CHAT_DISPLAYED(value);
}

let fields = computed<Dictionary<IField>>(() => {
    let emailField: ITextField = {
        placeholder: __("ENTER_YOUR_EMAIL"),
        icon: "at",
        name: KEY_EMAIL,
        type: CLIENT_DATA_TYPE_EMAIL,
        descr: null,
    };
    return {
        [KEY_EMAIL]: emailField,
        [KEY_CAPTCHA]: ConfigStore.siteParams.value.formElements[CLIENT_CAPTCHA_FIELD_NAME]
    };
});

let form = computed<CollectContactFields>(() => {
    return {
        [KEY_EMAIL]: COLLECT_CONTACT_FIELD_REQUIRED,
        [KEY_CAPTCHA]: COLLECT_CONTACT_FIELD_REQUIRED
    }
});

let instance = getCurrentInstance().proxy;

async function send() {
    isLoading.value = true;
    try {
        let result = await ChatApiRequest.make({
            method: "exportChatForClient",
            p: model.value
        });
        result.showMessage(instance);
        if (result.isSuccess()) {
            onVisibleUpdate(false);
        }
    } catch (e) {

    }
    isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createBlock(ChatModalMessage, {
        key: 0,
        visible: _unref(visible),
        "onUpdate:visible": onVisibleUpdate,
        title: _unref(__)('SAVE_CHAT')
      }, {
        default: _withCtx(() => [
          _createVNode(ChatForm, {
            form: _unref(form),
            "show-load": _unref(isLoading),
            fields: _unref(fields),
            modelValue: _unref(model),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
            button: _unref(__)('SEND'),
            onApply: send
          }, null, 8, ["form", "show-load", "fields", "modelValue", "button"])
        ]),
        _: 1
      }, 8, ["visible", "title"]))
    : _createCommentVNode("", true)
}
}

})